<template>
  <el-dialog title="出库单详情" :visible.sync="receiptNoVisible" :destroy-on-close="true" width="80%" top="5%"
    style="text-align: center">
    <div class="receiptRow">
      <div>
        <div>
          <span>出库单号：</span>
          <span>{{ rowData.outboundNo || "-" }}</span>
        </div>
        <div>
          <span>仓库：</span>
          <span>{{ rowData.warehouseName || "-" }}</span>
        </div>
        <div>
          <span>状态：</span>
          <span>{{ rowData.outboundStatusText || "-" }}</span>
        </div>
        <div>
          <span>创建时间：</span>
          <span>{{ rowData.createTime || "-" }}</span>
        </div>
        <div>
          <span>总箱数：</span>
          <span>{{ rowData.boxCount || "-" }}</span>
        </div>
        <div>
          <span>总托盘数：</span>
          <span>{{ rowData.palletQty || "-" }}</span>
        </div>
      </div>
      <div>
        <div>
          <span>参考单号：</span>
          <span>{{ rowData.orgOutboundNo || "-" }}</span>
        </div>
        <div>
          <span>客户货主：</span>
          <span>{{ rowData.customName || "-" }}</span>
        </div>
        <div>
          <span>预计发货：</span>
          <span>{{ rowData.deliveryDate || "-" }}</span>
        </div>
        <div>
          <span>实际发货：</span>
          <span>{{ rowData.actDeliveryDate || "-" }}</span>
        </div>
        <div>
          <span>已发箱数：</span>
          <span>{{ rowData.sendBoxCount || "-" }}</span>
        </div>
        <div>
          <span>打托总箱数：</span>
          <span>{{ rowData.palletBoxCount || "-" }}</span>
        </div>
      </div>
    </div>
    <el-tabs class="warehouseTabs" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="出库汇总" name="summary"></el-tab-pane>
      <el-tab-pane label="箱子列表" name="declare"></el-tab-pane>
    </el-tabs>
    <div class="warehouseTable">
      <el-table :data="tableData" border style="width: 100%" v-loading="tabLoading">
        <el-table-column v-for="(col, index) in column" :prop="col.prop" :width="col.width"
          :min-width="col.minWidth || '110'" :align="col.align || 'center'" :label="col.label" :key="index">
          <template slot-scope="scope">
            <template v-if="col.prop === 'actualBoxLength' && activeName == 'declare'">
              <div>{{scope.row.actualBoxLength }}*{{scope.row.actualBoxWidth }}*{{scope.row.actualBoxHeight }}</div>
            </template>
            <template v-else>
              <span>{{ scope.row[col.prop] }}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="toolbarPag">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="currentChange"
        @size-change="sizeChange" :page-sizes="pageConfig.pageSizes" :page-size="pageConfig.pageSize"
        :current-page="pageConfig.pageIndex" :total="pageConfig.total" style="float:right;">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import {
  getOutboundSendBoxDetail,
} from "@/api/outbound/outboundOrder.js";
export default {

  data() {
    return {
      rowData: {},
      tabLoading: false,
      allTableData: undefined,
      activeName: 'summary',
      pageConfig: {
        total: 0,
        pageIndex: 1,
        pageSize: 50,
        pageSizes: [10, 20, 50, 100]
      },
      tableData: [],
      column: [],
      declareColumn: [
        // 表格列配置
        {
          prop: "deliveryOrdeNo",
          label: "WMS进仓号",
          minWidth: "100",
        },
        {
          prop: "orgCustomerNo",
          label: "参考单号",
          minWidth: "150",
        },
        
        {
          prop: "customerBox",
          label: "箱号",
          minWidth: "120",
        },
        {
          prop: "boxMark",
          label: "唛头",
          minWidth: "100",
        },
        {
          prop: "boxStatusText",
          label: "状态",
          minWidth: "100",
        },
        {
          prop: "actualBoxLength",
          label: "尺寸（长*宽*高）",
          minWidth: "100",
        },
        {
          prop: "actualBoxWeight",
          label: "毛重",
          minWidth: "100",
        }
      ],
      summaryColumn: [
        {
          prop: "actualBoxWeight",
          label: "毛重(kg)",
        },
        {
          prop: "actualBoxVolume",
          label: "体积(cbm)",
        },
        {
          prop: "actualBoxLength",
          label: "长(cm)",
        },
        {
          prop: "actualBoxWidth",
          label: "宽(cm)",
        },
        {
          prop: "actualBoxHeight",
          label: "高(cm)",
        },
        {
          prop: "boxCount",
          label: "箱数",
        },
        {
          prop: "declareCName",
          label: "中文申报名称",
        },
        {
          prop: "declareEName",
          label: "英文申报名称",
        },
        {
          prop: "boxStatusText",
          label: "状态",
        },
      ],
      receiptNoVisible: false
    };
  },
  methods: {
    currentChange(val) {
      this.$set(this.pageConfig, 'pageIndex', val)
      this.setPagination(this.pageConfig)
    },
    sizeChange(val) {
      this.$set(this.pageConfig, 'pageSize', val);
      this.setPagination(this.pageConfig)
    },
    handleClick() {
      this.setTableColumn()
      this.setTableData()
    },
    setTableColumn() {
      if (this.activeName == 'summary') {
        this.column = this.summaryColumn
      } else {
        this.column = this.declareColumn
      }
    },
    setTableData() {
      this.setPagination({
        total: 0,
        pageIndex: 1,
        pageSize: 50,
        pageSizes: [10, 20, 50, 100]
      })
    },
    setPagination(pageConfig) {
      let tableData = []
      if (this.activeName == 'summary') {
        tableData = this.allTableData.summaryInventoryBoxList
      } else {
        tableData = this.allTableData.boxList
      }
      this.$set(this.pageConfig, 'total', tableData.length);
      this.$set(this.pageConfig, 'pageIndex', pageConfig.pageIndex);
      this.$set(this.pageConfig, 'pageSize', pageConfig.pageSize);
      let start = (pageConfig.pageIndex - 1) * pageConfig.pageSize
      this.tableData = tableData.slice(start, start + pageConfig.pageSize)
    },
    getOutboundSendBoxDetail(data) {
      this.tabLoading = true
      let para = {
        outboundID: data.tfOutboundID
      }
      getOutboundSendBoxDetail(para).then((res) => {
        this.tabLoading = false
        if (res.data && res.data.success) {
          this.allTableData = res.data.response
          this.setTableData()
        }
      })
    },
    showDialog(data) {
      this.rowData = data;
      this.activeName = 'summary'
      this.setTableColumn()
      this.tableData = []
      this.allTableData = {}
      this.receiptNoVisible = true
      this.getOutboundSendBoxDetail(data)
    }
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
.receiptRow {
  display: flex;
  margin-bottom: 10px;

  >div {
    flex: 1;

    >div {
      margin-bottom: 10px;
      display: flex;
      justify-content: left;

      >span {
        display: inline-block;
      }

      >span:first-child {
        width: 130px;
        text-align: right;
        margin-right: 10px;
      }

      >span:last-child {
        color: #000;
      }
    }
  }
}

.warehouseTabs {
    box-shadow: none;
    border-bottom: none;
    ::v-deep>.el-tabs__content {
        padding: 0 !important;
    }
}

.warehouseTable {
    border-top: none;
    max-height: 400px;
    overflow: auto;
    padding: 15px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    border: 1px solid #DCDFE6;
    border-top: none;
}


.toolbarPag {
  overflow: hidden;
  padding-top: 10px;
}
</style>

